import { Spacing } from "types/Spacing";

export const COLUMN_ORDER = "minmax(5rem, 5fr) 25rem";
export const COLUMN_GAP: Spacing = "large";
export const LEVEL_MARGIN = "3.2rem";
export const CONFIG_MANAGEMENT_TREE_LIST_ROW_TEST_ID = "config-management-tree-list-row";
export const STATIC_HEADER_OPTIONS = ["Name", "Status"];
export const LOADER_ROW_ID = "loaderRow";
